import { Menu } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

import { useHistory } from 'react-router-dom'
import { getNavUrl } from '@/utils/navigation';

const { SubMenu } = Menu;

export const Navigation = () => {
  const history = useHistory()

  const onClick = ({ key }: { key: string}) => {
    if (key.startsWith('@')) {
      if (key.startsWith('@/external')) {
        if (key === '@/external/install') {
          window.open('https://codesandbox.io/s/cranky-tree-bcsu8')
          return
        }

        if (key === '@/external/ga4shop') {
          window.open('https://ga4shop.com')
          return
        }

        return
      }

      if (key.startsWith('@/redirect')) {
        if (key === '@/redirect/manage') {
          history.push(getNavUrl('/manage'))
          return
        }

        return
      }

      return
    }

    history.push(getNavUrl(key))
  };

  return (
    <Menu
      onClick={(e) => onClick(e)}
      defaultSelectedKeys={['1']}
      defaultOpenKeys={['sub1']}
      mode="inline"
    >
      <Menu.Item key="/manage">실습 환경 설정</Menu.Item>
      <SubMenu key="step-01" icon={<AppstoreOutlined />} title="STEP 01 - 구글 애널리틱스 입문하기">
        <Menu.Item key="@/external/install">1.2 구글 애널리틱스 설치 체험하기</Menu.Item>
        <Menu.Item key="@/redirect/manage">1.3 데모 계정 연동하기</Menu.Item>
        <Menu.Item key="/about">5.1 이벤트 살펴보기</Menu.Item>
        <Menu.Item key="@/redirect/manage">5.2 디버그 모드 설정하기</Menu.Item>
        <Menu.Item key="/sign_up">5.4 직접 수집 이벤트 살펴보기</Menu.Item>
        <Menu.Item key="/item">6.1 이벤트 수집 계획하기</Menu.Item>
        <Menu.Item key="/item/strawberry">6.3 이벤트 매개변수 살펴보기</Menu.Item>
        <Menu.Item key="/sign_up">6.5 전환 이벤트 살펴보기</Menu.Item>
        <Menu.Item key="/sign_up">6.8 [실전!] 회원 가입 이벤트 분석하기</Menu.Item>
      </SubMenu>
      <SubMenu key="step-02" icon={<SettingOutlined />} title="STEP 02 - 구글 애널리틱스 파고들기">
        <Menu.Item key="/fb">9.1 캠페인 링크 살펴보기</Menu.Item>
        <Menu.Item key="/item/strawberry">[실전!] 캠페인 링크 만들기</Menu.Item>
        <Menu.Item key="/parameter">9.6 [필수!] 맞춤 등록 가능한 매개변수 파악하고 등록하기</Menu.Item>
        <Menu.Item key="/my">11.2 사용자 속성 수집 계획하기</Menu.Item>
        <Menu.Item key="/my">11.3 사용자 속성 코드 살펴보고 적용하기</Menu.Item>
        <Menu.Item key="/item/apple">12.2 페이지 기반 잠재고객 만들기</Menu.Item>
        <Menu.Item key="/user">13.1 구글 애널리틱스는 어떻게 사용자를 구분할까?</Menu.Item>
        <Menu.Item key="/item/apple">14.2 도착 이벤트 만들기</Menu.Item>
        <Menu.Item key="/cart">14.3 목표 이벤트 만들기</Menu.Item>
        <Menu.Item key="/item">15.1 잠재고객 트리거 살펴보기</Menu.Item>
        <Menu.Item key="@/external/ga4shop">16.1 전자상거래 실습 페이지 살펴보기</Menu.Item>
      </SubMenu>
      <SubMenu key="step-03" icon={<SettingOutlined />} title="STEP 03 - 구글 애널리틱스 활용하기">
        <Menu.Item key="/apk">실습 앱 설치하기</Menu.Item>
      </SubMenu>
      {/* <SubMenu key="step-04" icon={<SettingOutlined />} title="STEP 04 - 구글 애널리틱스로 앱 분석하기">
      </SubMenu> */}
      <SubMenu key="step-etc" icon={<SettingOutlined />} title="기타 참고 문서">
        <Menu.Item key="/update">업데이트 안내</Menu.Item>
        <Menu.Item key="/docs/user_id">USER ID 개발 문서</Menu.Item>
        <Menu.Item key="/docs/ecommerce">전자상거래 가이드 문서</Menu.Item>
        <Menu.Item key="/docs/ecommerce_dev">전자상거래 이벤트 문서</Menu.Item>
        <Menu.Item key="/docs/event">자동으로 수집되는 이벤트</Menu.Item>
        <Menu.Item key="/docs/remote_config">웹에서 리모트 컨피그 활용하기</Menu.Item>
        <Menu.Item key="/docs/cloud_messaging">웹에서 클라우드 메시징 활용하기</Menu.Item>
      </SubMenu>
    </Menu>
  )
}